import QrReader from 'react-web-qr-reader'
import styled from 'styled-components'

export const QRLogoWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  margin: 16px auto;
  @media (max-width: 500px) {
    width: 1000px;
  }
`

export const QrImage = styled.img`
  margin: 0 auto;
  height: 84%;
  width: 35%;
  object-fit: contain;
  @media (max-width: 500px) {
    width: 100%;
  }
`

export const QrScannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: 100%;
  height: 100%;
`

export const QrScanner = styled(QrReader)`
  margin: 0 auto;
`

export const VideoPlayerWrapper = styled.div`
  margin: 0 auto; 
`
